import { render } from "./InsightsTabs.vue?vue&type=template&id=c8eadff8"
import script from "./InsightsTabs.vue?vue&type=script&lang=js"
export * from "./InsightsTabs.vue?vue&type=script&lang=js"

import "./InsightsTabs.vue?vue&type=style&index=0&id=c8eadff8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__